export const DatePickerEvent = {
	SELECT_CHANGE: 'onSelectChange',
	BEFORE_SELECT: 'onBeforeSelect',
	SELECT: 'onSelect',
	BEFORE_DESELECT: 'onBeforeDeselect',
	DESELECT: 'onDeselect',
	DESTROY: 'onDestroy',
};
